export default "__VITE_ASSET__3d4755c1__"